import {
	HomeIcon,
	DashboardIcon,
	FloraIcon,
	ProductsIcon,
	ConsultantsIcon,
	ContactIcon,
	SettingsIcon,
	LogOutIcon,
	SidebarClipboardIcon,
	AdminIcon,
	FieldDiaryIcon,
	LogsIcon,
	MicroscopeIcon,
	TableIcon,
} from '@practium/ui';
import type { SidebarConfig } from '@practium/ui';
import { usePermissions } from '@practium/features/permissions';
import type { PermissionSubject } from '@practium/features/permissions';

const ALWAYS_VISIBLE_PATHS = ['/', '/flora-ai', '/diario-de-campo', '/solicitacoes', '/operacional'];

const ROUTE_PERMISSION_MAP: Record<string, PermissionSubject> = {
	'/dashboard': 'dashboard',
	'/produtos': 'products',
	'/usuarios': 'users',
	'/analises': 'samples',
	'/logs': 'logs',
	'/suporte': 'technical-support',
	'/parcelamento': 'parcelling',
};

export const useAdminSidebarConfig = (handleLogout: () => void): SidebarConfig => {
	const { abilities } = usePermissions();

	const canAccessSystem =
		abilities.can('read', 'groups') ||
		abilities.can('read', 'hierarchies') ||
		abilities.can('read', 'plans');

	const canAccess = (path: string): boolean => {
		if (path === '/sistema') return canAccessSystem;
		if (ALWAYS_VISIBLE_PATHS.includes(path)) return true;
		const subject = ROUTE_PERMISSION_MAP[path];
		return subject ? abilities.can('read', subject) : true;
	};

	const mainRoutes = [
		{
			path: '/',
			label: 'Home',
			icon: <HomeIcon />,
		},
		{
			path: '/dashboard',
			label: 'Dashboard',
			icon: <DashboardIcon />,
		},
		{
			path: '/flora-ai',
			label: 'Flora AI',
			icon: <FloraIcon />,
		},
		{
			path: '/diario-de-campo',
			label: 'Diário de campo',
			icon: <FieldDiaryIcon />,
		},
		{
			path: '/produtos',
			label: 'Produtos',
			icon: <ProductsIcon />,
		},
		{
			path: '/usuarios',
			label: 'Usuários',
			icon: <ConsultantsIcon />,
		},
		{
			path: '/analises',
			label: 'Análises',
			icon: <MicroscopeIcon />,
		},
		{
			path: '/suporte',
			label: 'Suporte',
			icon: <ContactIcon />,
		},
		{
			path: '/parcelamento',
			label: 'Parcelamento',
			icon: <TableIcon />,
		},
		{
			path: '/solicitacoes',
			label: 'Solicitações',
			icon: <SidebarClipboardIcon />,
		},
		{
			path: '/logs',
			label: 'Logs',
			icon: <LogsIcon />,
		},
		{
			path: '/sistema',
			label: 'Sistema',
			icon: <SettingsIcon />,
		},
		{
			path: '/operacional',
			label: 'Operacional',
			icon: <AdminIcon />,
		},
	].filter(route => canAccess(route.path));

	return {
		mainRoutes,
		footerRoutes: [
			{
				path: '/perfil',
				label: 'Preferências',
				icon: <SettingsIcon />,
			},
			{
				path: '/logout',
				label: 'Logout',
				icon: <LogOutIcon />,
				onClick: handleLogout,
			},
		],
		promotion: undefined,
	};
};
